import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPrice = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0F0F1A]/95 backdrop-blur-md border-b border-[#4361EE]/20 py-3' : 'bg-transparent py-5'}`} data-id="element-120">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-121">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-122">
          <ZapIcon className="w-5 h-5 text-[#4361EE]" data-id="element-123" />
          <span className="font-display text-2xl tracking-widest text-[#4361EE]" style={{
          fontFamily: "'Bebas Neue', sans-serif",
          letterSpacing: '0.15em'
        }} data-id="element-124">
            ADHD RESET
          </span>
        </div>

        {/* Nav links — hidden on mobile */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-[#A0AEC0]" data-id="element-125">
          <a href="#problem" className="hover:text-white transition-colors" data-id="element-126">
            The Problem
          </a>
          <a href="#what-you-get" className="hover:text-white transition-colors" data-id="element-127">
            What's Inside
          </a>
          <a href="#testimonials" className="hover:text-white transition-colors" data-id="element-128">
            Results
          </a>
          <a href="#pricing" className="hover:text-white transition-colors" data-id="element-129">
            Pricing
          </a>
        </div>

        {/* CTA */}
        <button onClick={scrollToPrice} className="bg-[#4361EE] hover:bg-[#3451DE] text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-all duration-200 tracking-wide uppercase" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-130">
          Get Instant Access
        </button>
      </div>
    </nav>;
}